import API from './api.js';
import Routing from './routing.js';
import TIMLRenderer from './timl_renderer.js';

export default class TIMLRuntime {
  static initialPageBuild() {
    const view = Routing.getRouteObject();
    const rootElement = TIMLRenderer.renderView(view.layout, view, TIMLRenderer.createRenderContext());
    document.body.appendChild(rootElement);
    this.setActiveAnchor();
    view.javascript();
    document.head.querySelector('style').innerHTML = view.css;
  }

  static loadPageContent() {
    API.currentPageId++;
    const view = Routing.getRouteObject();
    const pageElement = TIMLRenderer.renderView(view, '', TIMLRenderer.createRenderContext());
    const slot = document.querySelector('[component="?"]');
    slot.replaceChildren(pageElement);
    this.setActiveAnchor();
    view.javascript();
    document.head.querySelector('style').innerHTML = view.css;
  }

  static setActiveAnchor() {
    const active = document.querySelector('aside nav a.active');
    if (active) active.classList.remove('active');

    const anchor = document.querySelector(this.getActiveNavigationSelector());
    if (anchor) anchor.classList.add('active');
  }

  static getActiveNavigationSelector() {
    return `aside nav a[href="${this.getActiveNavigationHref()}"]`;
  }

  static getActiveNavigationHref() {
    const languageCode = Routing.getLanguageCodeFromPathName();
    const routeName = Routing.getRouteFromPathName();
    return routeName ? `/${languageCode}/${routeName}` : `/${languageCode}/`;
  }

  static shouldInterceptAnchor(target, event) {
    if (target.tagName !== 'A' || !target.getAttribute('href')) return false;
    if (target.hasAttribute('download')) return false;
    if (target.getAttribute('target') && target.getAttribute('target') !== '_self') return false;
    if (event.defaultPrevented || event.button !== 0) return false;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return false;

    const rawHref = target.getAttribute('href');
    if (!rawHref || rawHref.startsWith('#')) return false;

    const url = new URL(target.href, window.location.href);
    if (!['http:', 'https:'].includes(url.protocol)) return false;
    if (url.origin !== window.location.origin) return false;

    return this.isKnownSpaRoute(url);
  }

  static isKnownSpaRoute(url) {
    const parts = url.pathname.split('/').filter(Boolean);
    const pathWithoutLanguage = !parts.length
      ? '/'
      : (parts[0].length === 2 ? `/${parts.slice(1).join('/')}` || '/' : url.pathname);

    if (pathWithoutLanguage === '/') return true;
    return Boolean(Routing.matchRoute(Routing.routes, pathWithoutLanguage));
  }

  static handleAnchorClick(target) {
    const url = new URL(target.href, window.location.href);
    const href = url.pathname + url.search + url.hash;
    history.pushState(null, '', href);
    this.loadPageContent(href);
    if (window.innerWidth <= 950 && typeof hideAside === 'function') {
      hideAside();
    }
  }

  static clickIntercepter = (event) => {
    let target = event.target;

    while (target && target !== document.body) {
      if (target.tagName === 'A' && this.shouldInterceptAnchor(target, event)) {
        this.handleAnchorClick(target);
        event.preventDefault();
        return;
      }

      if (target.tagName === 'TR' && (target.dataset.href || target.classList.contains('clickable-row'))) {
        const selection = window.getSelection ? window.getSelection().toString() : '';
        if (!selection) {
          const anchor = target.querySelector('a[href]');
          if (anchor && this.shouldInterceptAnchor(anchor, event)) {
            this.handleAnchorClick(anchor);
            event.preventDefault();
            return;
          } else if (target.dataset.href) {
            const url = new URL(target.dataset.href, window.location.href);
            if (this.isKnownSpaRoute(url)) {
              this.handleRedirect(url.pathname + url.search + url.hash);
              event.preventDefault();
              return;
            }
          }
        }
      }

      target = target.parentElement;
    }
  }

  static handleRedirect(href) {
    history.pushState(null, '', href);
    this.loadPageContent(href);
  }

  static remove(selector) {
    const els = document.querySelectorAll(selector);
    if (els.length) els.forEach(el => el.remove());
  }
}
